import { CloseCircleOutlined } from '@ant-design/icons';

interface Props {
  regions?: { id: string; name: string }[];
  selectedRegionIds?: string[];
  selectedSort: { type: string; direction: 'asc' | 'desc' | null };
  onClearRegion?: (regionId: string) => void;
  onClearAllRegions?: () => void;
  onClearSort: () => void;
}

export function SelectedFilters({
  regions,
  selectedRegionIds,
  selectedSort,
  onClearRegion,
  onClearAllRegions,
  onClearSort,
}: Readonly<Props>) {
  const hasRegions = selectedRegionIds && selectedRegionIds.length > 0;
  const hasSort = !!selectedSort.direction;

  const totalFilters = selectedRegionIds
    ? selectedRegionIds.length
    : 0 + (hasSort ? 1 : 0);

  const handleClearAll = () => {
    onClearAllRegions && onClearAllRegions();
    onClearSort();
  };

  if (!hasRegions && !hasSort) return null;
  return (
    <div className='flex flex-wrap gap-2 my-4'>
      {selectedRegionIds &&
        selectedRegionIds.map((id) => {
          const regionName = regions && regions.find((r) => r.id === id)?.name;
          return (
            <span
              key={id}
              className='bg-wl-primary/10 text-sm px-3 py-1 rounded-full flex items-center text-wl-primary'
            >
              {regionName}
              <button
                onClick={() => onClearRegion && onClearRegion(id)}
                className='ml-2 hover:text-wl-primary'
              >
                <CloseCircleOutlined />
              </button>
            </span>
          );
        })}
      {hasSort && (
        <span className='bg-gray-200 text-sm px-3 py-1 rounded-full flex items-center text-gray-800'>
          Sort: {selectedSort.type} ({selectedSort.direction})
          <button onClick={onClearSort} className='ml-2 hover:text-red-600'>
            <CloseCircleOutlined />
          </button>
        </span>
      )}
      {totalFilters > 1 && (
        <span className='text-sm bg-gray-300 ml-4 px-3 py-1 space-x-2 rounded-full'>
          Clear All
          <button
            onClick={() => handleClearAll()}
            className='ml-2 hover:text-gray-3'
          >
            <CloseCircleOutlined />
          </button>
        </span>
      )}
    </div>
  );
}
